// import { useState, useEffect, useContext } from 'react';
// import AdminContext from '../../StateContext/Application';
// import { apiurl } from '../../../../path';
// import { useNavigate } from 'react-router-dom';
// import { useLanguage } from '../../../../lang/langcontext/LanguageContext';
// const PrograseList = () => {
//     const { language, toggleLanguage, t } = useLanguage();
//     const context = useContext(AdminContext);
//     const { GetProgressReportOutwardsFucntion, GetBudgetHeadInfo } = context;
//     const [progressList, setProgressList] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filteredProgress, setFilteredProgress] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [statusofData, setstatusofData] = useState("Pending");
//     const [UserRole, setUserRole] = useState("");
//     const [AllDistrict, setAllDistrict] = useState([]);
//     const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
//     const [SelectedDistrict, setSelectedDistrict] = useState("");
//     const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");

//     const getProgressOutwardList = async () => {
//         try {
//             let res = await GetProgressReportOutwardsFucntion();
//             const { status, message, Tabletype } = res;

//             if (status) {
//                 const sortedData = message.sort((a, b) =>
//                     new Date(a.Date) - new Date(b.Date)
//                 );
//                 console.log("✅ Progress Report Outwards Data:", sortedData);
//                 setProgressList(sortedData);
//                 setUserRole(Tabletype);
//             }
//             else {
//                 alert(message);
//             }
//         } catch (error) {
//             console.error("❌ Error fetching progress report outwards:", error);
//         }
//     };

//     useEffect(() => {
//         getProgressOutwardList();
//     }, []);

//     // --- Search Filter ---
//     // useEffect(() => {
//     //     const lower = searchTerm.toLowerCase();
//     //     const filtered = progressList.filter(item =>
//     //         Object.values(item).some(val =>
//     //             (val || '').toString().toLowerCase().includes(lower)
//     //         )
//     //     );
//     //     setFilteredProgress(filtered);
//     //     setCurrentPage(1);
//     // }, [searchTerm, progressList]);

//     useEffect(() => {
//         let filtered = progressList;

//         // if (SelectedTalukasofDistrict) {
//         //     filtered = filtered.filter(item => item.Status == statusofData && item.District == SelectedDistrict && item.Taluka == SelectedTalukasofDistrict);
//         // }

//         // if (SelectedDistrict) {
//         //     filtered = filtered.filter(item => item.Status == statusofData && item.District == SelectedDistrict);
//         // }

//         // if (statusofData || SelectedDistrict == "" || SelectedTalukasofDistrict == "") {
//         //     filtered = filtered.filter(item => item.Status == statusofData);
//         // }

//         if (SelectedDistrict) {
//             filtered = filtered.filter(item => item.District == SelectedDistrict);
//         }

//         if (SelectedTalukasofDistrict) {
//             filtered = filtered.filter(item => item.Taluka == SelectedTalukasofDistrict);
//         }

//         if (statusofData) {
//             if (statusofData == "false") {
//                 filtered = filtered.filter(
//                     item => item.Status !== "Rejected" && (item.Approvance1 == statusofData || item.Approvance2 == statusofData)
//                 );
//             }
//             else if (statusofData == "Rejected") {
//                 filtered = filtered.filter(item => item.Status === statusofData);
//             }
//         }

//         if (statusofData == "") {
//             filtered = progressList;
//         }

//         if (searchTerm.trim() !== "") {
//             const lower = searchTerm.toLowerCase();
//             filtered = filtered.filter(bill =>
//                 Object.values(bill).some((val) =>
//                     (val || '').toString().toLowerCase().includes(lower)
//                 )
//             );
//         }

//         setFilteredProgress(filtered);
//         setCurrentPage(1);

//     }, [statusofData, searchTerm, progressList, SelectedDistrict, SelectedTalukasofDistrict]);

//     // useEffect(() => {
//     //     setCurrentPage(1);
//     // }, [searchTerm]);

//     const itemsPerPage = 10;
//     const totalPages = Math.ceil(filteredProgress.length / itemsPerPage);
//     const indexOfLastBill = currentPage * itemsPerPage;
//     const indexOfFirstBill = indexOfLastBill - itemsPerPage;
//     const currentItems = filteredProgress.slice(indexOfFirstBill, indexOfLastBill);

//     const FetchGramPanachayatInfo = async () => {
//         try {
//             let res = await GetBudgetHeadInfo('null', "AllDistrict");
//             // console.log("Data i get:: ", res);
//             setAllDistrict(res);
//         }
//         catch (err) {
//             console.log(err);
//         }
//     }

//     useEffect(() => {
//         FetchGramPanachayatInfo();
//     }, []);

//     useEffect(() => {
//         if (SelectedDistrict) {
//             let res = AllDistrict.filter((item) => item.District_Marathi === SelectedDistrict);
//             setTalukasofDistrict(res);
//         }
//         else {
//             setSelectedDistrict("");
//             setSelectedTalukasofDistrict("");
//             setTalukasofDistrict([]);
//         }
//     }, [SelectedDistrict]);

//     return (

//         <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//                 <div className='col-12'>
//                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         {/* <h4 style={{ margin: "10px" }}>Project List</h4> */}
//                         <h5 className='my-auto fw-bold'>
//                             <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                             <span className='my-auto'>{t('Progress Report Outwards')}</span>
//                         </h5>

//                         <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
//                             <select
//                                 placeholder='Choose District'
//                                 value={statusofData}
//                                 onChange={(e) => setstatusofData(e.target.value)}
//                                 style={{
//                                     width: "100%",
//                                     padding: "8px 12px 8px 8px",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "8px",
//                                     backgroundColor: "#ffffffff",
//                                     fontSize: "18px",
//                                     color: "#333",
//                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                     outline: "none"
//                                 }}>
//                                 <option value="">All</option>
//                                 <option value="false">Pending</option>
//                                 <option value="Rejected">Rejected</option>

//                             </select>
//                         </div>

//                         {
//                             UserRole == "State" && (
//                                 <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
//                                     <select
//                                         placeholder='Choose District'
//                                         value={SelectedDistrict}
//                                         onChange={(e) => setSelectedDistrict(e.target.value)}
//                                         style={{
//                                             width: "100%",
//                                             padding: "8px 12px 8px 8px",
//                                             border: "1px solid #ccc",
//                                             borderRadius: "8px",
//                                             backgroundColor: "#ffffffff",
//                                             fontSize: "18px",
//                                             color: "#333",
//                                             boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                             outline: "none"
//                                         }}>
//                                         <option value="" >Select District</option>
//                                         {
//                                             AllDistrict &&
//                                             [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
//                                                 return (
//                                                     <option key={index} value={district}>{district}</option>
//                                                 )
//                                             })
//                                         }
//                                     </select>
//                                 </div>
//                             )
//                         }

//                         {
//                             UserRole == "State" && (
//                                 <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
//                                     <select
//                                         placeholder='Choose Taluka'
//                                         value={SelectedTalukasofDistrict}
//                                         onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
//                                         style={{
//                                             width: "100%",
//                                             padding: "8px 12px 8px 8px",
//                                             border: "1px solid #ccc",
//                                             borderRadius: "8px",
//                                             backgroundColor: "#ffffffff",
//                                             fontSize: "18px",
//                                             color: "#333",
//                                             boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                             outline: "none"
//                                         }}>
//                                         <option value="" disabled>Select Taluka</option>
//                                         {
//                                             TalukasofDistrict.length > 0 &&
//                                             TalukasofDistrict.map((val, index) => {
//                                                 return (
//                                                     <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
//                                                 )
//                                             })
//                                         }
//                                     </select>
//                                 </div>
//                             )
//                         }

//                         <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
//                             <img
//                                 src="/Search32.png"
//                                 alt="Search Icon"
//                                 style={{
//                                     position: "absolute",
//                                     top: "50%",
//                                     left: "10px",
//                                     transform: "translateY(-50%)",
//                                     width: "16px",
//                                     height: "16px",
//                                     opacity: 0.6
//                                 }}
//                             />
//                             <input
//                                 type="text"
//                                 placeholder={t('Search')}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 value={searchTerm}
//                                 style={{
//                                     width: "100%",
//                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
//                                     border: "1px solid #ccc",
//                                     borderRadius: "8px",
//                                     backgroundColor: "#f1f6fc",
//                                     fontSize: "18px",
//                                     color: "#333",
//                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                     outline: "none"
//                                 }}
//                             />
//                         </div>
//                     </div>

//                     <div className='col-12 pb-5'>
//                         <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
//                             <div
//                                 className="col-12 tableDesign"
//                                 style={{ background: "#2C78DB", overflowX: "scroll" }}
//                             >
//                                 <table
//                                     className="m-0 p-0"
//                                     style={{ width: "100%", borderCollapse: "collapse" }}
//                                 >
//                                     <thead>
//                                         <tr
//                                             style={{
//                                                 color: "white",
//                                                 border: "none",
//                                                 height: "3rem",
//                                                 fontSize: "18px",
//                                             }}
//                                         >
//                                             <th style={{ padding: "7px 10px", minWidth: "60px" }}>{t("Sr.No.")}</th>
//                                             {/* <th style={{ padding: "7px 10px", minWidth: "160px" }}>Common WorkOrder ID</th> */}

//                                             <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Head Code")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "150px" }}>{t("Year")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "150px" }}>{t("MHUID Number")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Work Name")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "150px" }}>{t("District")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "150px" }}>{t("Taluka")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "150px" }}>{t("Physical Progress (%)")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "220px" }}>{t("File Upload")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "150px" }}>{t("Date")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Rejected?")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Remark")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Approval 1")}</th>
//                                             <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Approval 2")}</th>

//                                         </tr>
//                                     </thead>

//                                     <tbody>
//                                         {currentItems?.length === 0 ? (
//                                             <tr>
//                                                 <td
//                                                     colSpan="16"
//                                                     style={{
//                                                         textAlign: "center",
//                                                         padding: "20px",
//                                                         backgroundColor: "#f9f9f9",
//                                                     }}
//                                                 >
//                                                     {t("No data available")}
//                                                 </td>
//                                             </tr>
//                                         ) : (
//                                             currentItems?.map((proposal, index) => {
//                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                 const statusBox = (value) => {
//                                                     if (value === "true") {
//                                                         return (
//                                                             <div
//                                                                 className="m-auto"
//                                                                 style={{
//                                                                     width: "20px",
//                                                                     height: "20px",
//                                                                     borderRadius: "6px",
//                                                                     backgroundColor: "#16C60C",
//                                                                     display: "flex",
//                                                                     justifyContent: "center",
//                                                                     alignItems: "center",
//                                                                     color: "white",
//                                                                     fontWeight: "bold",
//                                                                 }}
//                                                             >
//                                                                 ✓
//                                                             </div>
//                                                         );
//                                                     } else if (value === "false") {
//                                                         return (
//                                                             <div
//                                                                 className="m-auto"
//                                                                 style={{
//                                                                     width: "20px",
//                                                                     height: "20px",
//                                                                     borderRadius: "6px",
//                                                                     backgroundColor: "#dc2626",
//                                                                     display: "flex",
//                                                                     justifyContent: "center",
//                                                                     alignItems: "center",
//                                                                     color: "white",
//                                                                     fontWeight: "bold",
//                                                                 }}
//                                                             >
//                                                                 ✕
//                                                             </div>
//                                                         );
//                                                     } else {
//                                                         return "-";
//                                                     }
//                                                 };

//                                                 return (
//                                                     <tr style={{ backgroundColor: bgColor }} key={index}>
//                                                         <td style={{ padding: "8px" }}>{index + 1}</td>
//                                                         {/* <td style={{ padding: "8px" }}>
//                                                                {proposal.CommonWorkOrderID || "-"}
//                                                              </td> */}

//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.Head_Code || "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.ProposalYear || "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.TechnicalUID || "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.WorkOrderNo || "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.District || "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.Taluka || "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.physicalValue || "0"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.Upload ? (
//                                                                 <a
//                                                                     href={`${apiurl}/Uploads/${proposal.Upload}`}
//                                                                     target="_blank"
//                                                                     rel="noreferrer"
//                                                                 >
//                                                                     {proposal.Upload}
//                                                                 </a>
//                                                             ) : (
//                                                                 <span className="text-danger fw-bold">No File</span>
//                                                             )}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.Date
//                                                                 ? new Date(proposal.Date).toLocaleString()
//                                                                 : "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.Status == "Pending" ? "NO" : "YES"}
//                                                         </td>
//                                                         <td style={{ padding: "8px" }}>
//                                                             {proposal.Remark || "-"}
//                                                         </td>
//                                                         <td style={{ padding: "8px", textAlign: "center" }}>
//                                                             {statusBox(proposal.Approvance1)}
//                                                         </td>
//                                                         <td style={{ padding: "8px", textAlign: "center" }}>
//                                                             {statusBox(proposal.Approvance2)}
//                                                         </td>

//                                                     </tr>
//                                                 );
//                                             })
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>

//                             <div className='col-12 mt-4 mb-2'>
//                                 <div className="row">
//                                     <div className='col-6'>
//                                         <p className="text-gray-600" style={{ fontSize: "18px" }}>{t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredProgress.length)} {t("of")} {filteredProgress.length} {t("entries")}</p>
//                                     </div>
//                                     <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
//                                         <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
//                                         <button
//                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                             {currentPage}
//                                         </button>
//                                         <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
//                                         <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages || totalPages === 0}
//                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PrograseList;

import { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import GooglePagination from "../../styles/GooglePagination";
import CommonFilters from '../../../../utils/CommonFilters';
const PrograseList = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetProgressReportOutwardsFucntion, GetBudgetHeadInfo, Usermenu } =
    context;
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [progressData, setProgressData] = useState([]);
  const [progressList, setProgressList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProgress, setFilteredProgress] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusofData, setstatusofData] = useState("");
  const [UserRole, setUserRole] = useState("");
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
    useState("");
  const [openDistrict, setOpenDistrict] = useState(false);
  const [RoleID, setroleID] = useState(null);
  const [loading, setloading] = useState(false);
  const [typeofData, settypeofData] = useState("District");
  const [SelectedHeadCode, setSelectedHeadCode] = useState("");
  const [LoggedUserDistrict, setLoggedUserDistrict] = useState("");
  const [totalProgressCount, setTotalProgressCount] = useState(0);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [userDepartmentIds, setUserDepartmentIds] = useState([]);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredProgress.length / itemsPerPage);
  const indexOfLastBill = currentPage * itemsPerPage;
  const indexOfFirstBill = indexOfLastBill - itemsPerPage;
  const sortedProgress = Array.isArray(filteredProgress)
    ? filteredProgress
        .slice() // ✅ prevent state mutation
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];
  const currentItems = sortedProgress.slice(indexOfFirstBill, indexOfLastBill);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const [exportingPDF, setExportingPDF] = useState(false);
  const displayedGRS = exportingPDF ? filteredProgress : currentItems;

  const getDepartmentKey = (item) => {
  const ids = String(item?.DepartmentAccessID ?? "").match(/\d+/g) || [];
  return ids.includes("1") ? "1" : ids[0] || "";
};

  const getProgressOutwardList = async () => {
    try {
      let res = await GetProgressReportOutwardsFucntion();
      const { status, message, Tabletype } = res;

      if (status) {
        const sortedData = message.sort(
          (a, b) => new Date(a.Date) - new Date(b.Date),
        );
        console.log("✅ Progress Report Outwards Data:", sortedData);
        setProgressList(sortedData);
        setUserRole(Tabletype);
      } else {
        alert(message);
      }
    } catch (error) {
      console.error("❌ Error fetching progress report outwards:", error);
    }
  };
  const allDistricts = [
  ...new Set(
    AllDistrict
      ?.map((d) =>
        d?.District_Marathi?.split("-")[0]?.trim()
      )
      .filter(Boolean)
  )
].sort();

const isAllSelected =
  allDistricts.length > 0 &&
  SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };

  const handleDistrictToggle = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };
  useEffect(() => {
    getProgressOutwardList();
  }, []);

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      // Logged-in user's district
      setLoggedUserDistrict(data?.Data?.District);
      // "[1,2]", [1,2], "1,2" -> ["1", "2"]
      const ids = String(data?.Data?.DepartmentAccessID ?? "").match(/\d+/g) || [];
      setUserDepartmentIds(ids);
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };

  const showDepartmentFilter =
    userDepartmentIds.includes("1") && userDepartmentIds.includes("2");

  //       useEffect(() => {
  //        let filtered = [...progressList]; // clone array

  //        // 🔹 District filter
  //        if (SelectedDistrict) {
  //            filtered = filtered.filter(
  //                item => item.District === SelectedDistrict
  //            );
  //        }

  //        // 🔹 Taluka filter (only when user selects)
  //        if (SelectedTalukasofDistrict) {
  //            filtered = filtered.filter(
  //                item => item.Taluka === SelectedTalukasofDistrict
  //            );
  //        }

  //    // 🔹 Status filter
  //     if (statusofData) {
  //         if (statusofData === "Pending") {
  //             filtered = filtered.filter(
  //                 item => item.Status == "Pending" &&
  //                     (
  //                         item.Approvance1 === "false" ||
  //                         item.Approvance2 === "false"
  //                     )
  //             );
  //         }
  //         else if (statusofData === "Rejected") {
  //             filtered = filtered.filter(
  //                 item => item.Status === "Rejected"
  //                  &&
  //                        (
  //                            item.Approvance1 === "false" ||
  //                            item.Approvance2 === "false"
  //                        )
  //             );
  //         } else {
  //                filtered = filtered.filter(
  //                    item => item.Status === statusofData
  //                );
  //            }
  //     }

  //        // 🔹 Search filter (always last)
  //        if (searchTerm.trim()) {
  //            const lower = searchTerm.toLowerCase();
  //            filtered = filtered.filter(item =>
  //                Object.values(item).some(val =>
  //                    String(val ?? "")
  //                        .toLowerCase()
  //                        .includes(lower)
  //                )
  //            );
  //        }

  //        setFilteredProgress(filtered);
  //        setCurrentPage(1);

  //    }, [
  //        progressList,
  //        SelectedDistrict,
  //        SelectedTalukasofDistrict,
  //        statusofData,
  //        searchTerm
  //    ]);

  useEffect(() => {
    let filtered = [...progressList]; // clone array
    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.Head_Code ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054", filtered);
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) => item.Head_Code === "2515-1238(MLA Representative)",
      );
    }
    // 🔹 District filter (MULTI)
     if (SelectedDistrict && SelectedDistrict.length > 0) {
      filtered = filtered.filter((item) => {
        const itemDistrict =
          item.District || item.District_Marathi || "";

        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
}

    // 🔹 Taluka filter (single select – unchanged)
    if (SelectedTalukasofDistrict) {
      filtered = filtered.filter(
        (item) => item.Taluka === SelectedTalukasofDistrict,
      );
    }

    // 🔹 Head Code filter
    if (SelectedHeadCode) {
      filtered = filtered.filter((item) => item.Head_Code === SelectedHeadCode);
    }

    // // 🔹 Status filter
    // if (statusofData) {
    //   if (statusofData === "Pending") {
    //     filtered = filtered.filter(
    //       (item) =>
    //         item.Status === "Pending" &&
    //         (item.Approvance1 === "false" || item.Approvance2 === "false"),
    //     );
    //   } else if (statusofData === "Rejected") {
    //     filtered = filtered.filter(
    //       (item) =>
    //         item.Status === "Rejected" &&
    //         (item.Approvance1 === "false" || item.Approvance2 === "false"),
    //     );
    //   } else if (statusofData === "Approved") {
    //     // ✅ Added block
    //     filtered = filtered.filter(
    //       (item) => item.Approvance1 === "true" && item.Approvance2 === "true",
    //     );
    //   } else {
    //     filtered = filtered.filter((item) => item.Status === statusofData);
    //   }
    // }
        // 🔹 Status filter
    if (statusofData) {
      if (statusofData === "Pending") {
        filtered = filtered.filter(
          item =>
            item.Status === "Pending" &&
            (
              item.Approvance1 === "false"
              // item.Approvance2 === "false"
            )
        );
      }
      else if (statusofData === "Rejected") {
        filtered = filtered.filter(
          item =>
            item.Status === "Rejected" &&
            (
              item.Approvance1 === "false" ||
              item.Approvance2 === "false"
            )
        );
      }
      else if (statusofData === "Approved") {   // ✅ Added block
        filtered = filtered.filter(
          item =>
            item.Status === "Pending" &&
            item.Approvance1 === "true"
          // item.Approvance2 === "true"
        );
      }
      else {
        filtered = filtered.filter(
          item => item.Status === statusofData
        );
      }
    }

     // 🔹 Department filter
    if (selectedDepartment) {
      filtered = filtered.filter(
        (item) => getDepartmentKey(item) === selectedDepartment
      );
    }

    // 🔹 Search filter (always last)
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }

     // RoleID 80/81 → always restrict to 2515 records only (hide every other head code)
    if (RoleID === 80 || RoleID === 81) {
      filtered = filtered.filter((item) => item.Head_Code?.startsWith("2515"));
    }
    
    setTotalProgressCount(filtered.length);

    // Hide Jalna/Nanded records by default for District login
if (
  (LoggedUserDistrict === "जालना" ||
    LoggedUserDistrict === "नांदेड") &&
  RoleID !== 40 &&
  RoleID !== 41 &&
  RoleID !== 80 &&
  RoleID !== 81 &&
  SelectedDistrict.length === 0 &&
  !SelectedHeadCode
) {
  filtered = filtered.filter((item) => {
    const is2515 = item.Head_Code?.startsWith("2515");
    const itemDistrict = item.District || item.District_Marathi || "";

    const isJalnaNanded =
      itemDistrict === "जालना" ||
      itemDistrict.startsWith("जालना-") ||
      itemDistrict === "नांदेड" ||
      itemDistrict.startsWith("नांदेड-");

    return !(is2515 && isJalnaNanded);
  });
}

// Hide Jalna/Nanded by default for State RoleID 40/41
if (
  (RoleID === 40 || RoleID === 41) &&
  SelectedDistrict.length === 0
) {
  filtered = filtered.filter((item) => {
    const itemDistrict = item.District || item.District_Marathi || "";

    return !(
      itemDistrict === "जालना" ||
      itemDistrict.startsWith("जालना-") ||
      itemDistrict === "नांदेड" ||
      itemDistrict.startsWith("नांदेड-")
    );
  });
}


    setFilteredProgress(filtered);
    setCurrentPage(1);
  }, [
    progressList,
    SelectedDistrict, // now array
    SelectedTalukasofDistrict,
    statusofData,
    searchTerm,
    typeofData,
    SelectedHeadCode,
    selectedDepartment,
  ]);
  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
    getmenu();
  }, []);

  useEffect(() => {
    if (SelectedDistrict?.length > 0) {
      console.log("Selected Districts:", SelectedDistrict);

      const res = AllDistrict.filter((item) =>
        SelectedDistrict.includes(item.District_Marathi),
      );

      if (SelectedDistrict.length > 1) {
        setTalukasofDistrict([]);
      } else {
        setTalukasofDistrict(res);
      }
    } else {
      setSelectedDistrict("");
      setSelectedTalukasofDistrict("");
      setTalukasofDistrict([]);
      setSelectedHeadCode("");
    }
  }, [SelectedDistrict]);

  useEffect(() => {
    setSelectedTalukasofDistrict("");
    setSelectedHeadCode("");
  }, [SelectedDistrict]);

  const exportTableByClassToExcel = async (
    filteredProgress,
    filename = "Progress_Report.xlsx",
  ) => {
    if (!filteredProgress || filteredProgress.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const excelData = filteredProgress.map((proposal, index) => {
        // Handle Upload field (string | JSON array)
        let uploadFiles = "No File";
        if (proposal.Upload) {
          try {
            const parsed = JSON.parse(proposal.Upload);
            uploadFiles = Array.isArray(parsed)
              ? parsed.join(", ")
              : proposal.Upload;
          } catch {
            uploadFiles = proposal.Upload;
          }
        }

        return {
          "Sr.No": index + 1,
          "Head Code": proposal.Head_Code || "-",
          Year: proposal.ProposalYear || "-",
           "MHUID Number":
            !proposal.TechnicalUID ||
            String(proposal.TechnicalUID).trim().toUpperCase() === "NULL" ||
            String(proposal.TechnicalUID).trim().toLowerCase() === "undefined" ||
            String(proposal.TechnicalUID).trim() === ""
              ? "-"
              : proposal.TechnicalUID,
          "Work Name": proposal.WorkOrderNo || "-",
          "Job ID": proposal.JobID || "-",
          District: proposal.District || "-",
          Taluka: proposal.Taluka || "-",
          "Physical Progress (%)": proposal.physicalValue || "0",
          // "File Upload": uploadFiles,
          "Creation Date": proposal.Date
            ? new Date(proposal.Date).toLocaleString("en-IN")
            : "-",
          "Rejected?": proposal.Status === "Pending" ? "NO" : "YES",
          Remark: proposal.Remark || "-",

          // Approval columns (same symbols as UI)
          "Deputy Engineer Approval":
            proposal.Approvance1 === "true"
              ? "✓"
              : proposal.Approvance1 === "false"
                ? "✕"
                : "-",

          // "Department HOD Approval":
          //   proposal.Approvance2 === "true"
          //     ? "✓"
          //     : proposal.Approvance2 === "false"
          //       ? "✕"
          //       : "-"
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 24 }));
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: { r: excelData.length, c: Object.keys(excelData[0]).length - 1 },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Progress Report");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };

  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   const CHUNK_SIZE = 500;

  //   const originalTable = document.querySelector(`.${tableClass}`);
  //   if (!originalTable) {
  //     setExportingPDF(false);
  //     return;
  //   }
  //   setExportingPDF(true);
  //   setloading(true);
  //   await new Promise((res) => setTimeout(res, 300));
  //   const originalRows = originalTable.querySelectorAll("tbody tr");
  //   const totalRows = originalRows.length;

  //   for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
  //     const end = Math.min(start + CHUNK_SIZE, totalRows);

  //     // 🔥 Clone table
  //     const table = originalTable.cloneNode(true);
  //     const rows = table.querySelectorAll("tbody tr");

  //     // Remove rows outside current chunk
  //     rows.forEach((row, index) => {
  //       if (index < start || index >= end) {
  //         row.remove();
  //       }
  //     });

  //     document.body.appendChild(table);

  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     const topMargin = 25;
  //     const sideMargin = 10;
  //     const bottomMargin = 15;

  //     pdf.setFontSize(16);
  //     pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
  //       align: "center",
  //     });

  //     const canvas = await html2canvas(table, {
  //       scale: 1,
  //       useCORS: true,
  //       backgroundColor: "#2C78DB",
  //     });

  //     const imgWidth = pageWidth - sideMargin * 2;

  //     const pxToMm = imgWidth / canvas.width;
  //     const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //     const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //     let renderedHeight = 0;
  //     let pageNumber = 0;

  //     while (renderedHeight < canvas.height) {
  //       const sliceHeight = Math.min(
  //         usablePageHeightPx,
  //         canvas.height - renderedHeight,
  //       );

  //       const pageCanvas = document.createElement("canvas");
  //       const context = pageCanvas.getContext("2d");

  //       pageCanvas.width = canvas.width;
  //       pageCanvas.height = sliceHeight;

  //       context.drawImage(
  //         canvas,
  //         0,
  //         renderedHeight,
  //         canvas.width,
  //         sliceHeight,
  //         0,
  //         0,
  //         canvas.width,
  //         sliceHeight,
  //       );

  //       const imgData = pageCanvas.toDataURL("image/jpeg", 0.7);

  //       if (pageNumber > 0) pdf.addPage();

  //       pdf.addImage(
  //         imgData,
  //         "JPEG",
  //         sideMargin,
  //         topMargin,
  //         imgWidth,
  //         sliceHeight * pxToMm,
  //       );

  //       renderedHeight += sliceHeight;
  //       pageNumber++;
  //     }

  //     pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

  //     document.body.removeChild(table);
  //   }
  //   setloading(false);
  //   setExportingPDF(false);
  // };


    const downloadTableOnlyAsPDF = async (
      tableClass,
      filename,
      title
    ) => {
      const CHUNK_SIZE = 500;
  
      //Added New Line
      if (
        !Array.isArray(filteredProgress) ||
        filteredProgress.length === 0
      ) {
        alert("No data available");
        return;
      }
  
      setExportingPDF(true);
      setloading(true);
  
      try {
        const previousPage = currentPage;   //Added New Line
        setCurrentPage(1);
        await new Promise((resolve) =>
          setTimeout(resolve, 500)
        );
  
        const originalTable = document.querySelector(
          `.${tableClass}`
        );
  
        if (!originalTable) {
          alert("Table not found");
          return;
        }
  
        const originalRows =
          originalTable.querySelectorAll(
            "tbody tr"
          );
  
        const totalRows =
          filteredProgress.length;
  
        console.log(
          "Total records for PDF:",
          totalRows
        );
  
        for (
          let start = 0;
          start < totalRows;
          start += CHUNK_SIZE
        ) {
  
          const end = Math.min(start + CHUNK_SIZE, totalRows);
  
          // Added new condition to check if the table has rows before cloning
          const table = originalTable.cloneNode(true);
          const tbody = table.querySelector("tbody");
          if (tbody) {
            const rows = Array.from(
              tbody.querySelectorAll("tr")
            );
            // Reverse rows
            rows.reverse().forEach((row) => {
              tbody.appendChild(row);
            });
            // Fix Sr.No after reversing
            const updatedRows = Array.from(
              tbody.querySelectorAll("tr")
            );
            updatedRows.forEach((row, index) => {
              const firstCell = row.querySelector("td");
              if (firstCell) {
                firstCell.innerText = index + 1;
              }
            });
          }
          const rows = table.querySelectorAll("tbody tr");
  
          rows.forEach((row, index) => {
            if (
              index < start ||
              index >= end
            ) {
              row.remove();
            }
          });
  
          //Added New style
          table.style.position = "absolute";
          table.style.left = "-99999px";
          table.style.top = "0";
  
          document.body.appendChild(table);
  
          const pdf = new jsPDF(
            "p",
            "mm",
            "a4"
          );
  
          const pageWidth =
            pdf.internal.pageSize.getWidth();
  
          const pageHeight =
            pdf.internal.pageSize.getHeight();
  
          const topMargin = 25;
          const sideMargin = 10;
          const bottomMargin = 15;
  
          pdf.setFontSize(16);
  
          pdf.text(
            `${title} (${start + 1} - ${end})`,
            pageWidth / 2,
            15,
            {
              align: "center"
            }
          );
  
          const canvas =
            await html2canvas(
              table,
              {
                scale: 1,
                useCORS: true,
                backgroundColor: "#2C78DB"
              }
            );
  
          const imgWidth =
            pageWidth -
            sideMargin * 2;
  
          const pxToMm =
            imgWidth /
            canvas.width;
  
          const usablePageHeightMm =
            pageHeight -
            topMargin -
            bottomMargin;
  
          const usablePageHeightPx =
            usablePageHeightMm /
            pxToMm;
  
          let renderedHeight = 0;
          let pageNumber = 0;
  
          while (
            renderedHeight <
            canvas.height
          ) {
  
            const sliceHeight =
              Math.min(
                usablePageHeightPx,
                canvas.height -
                renderedHeight
              );
  
            const pageCanvas =
              document.createElement(
                "canvas"
              );
  
            const context =
              pageCanvas.getContext("2d");
  
            pageCanvas.width =
              canvas.width;
  
            pageCanvas.height =
              sliceHeight;
  
            context.drawImage(
              canvas,
  
              0,
              renderedHeight,
  
              canvas.width,
              sliceHeight,
  
              0,
              0,
  
              canvas.width,
              sliceHeight
            );
  
            const imgData =
              pageCanvas.toDataURL(
                "image/jpeg",
                0.7
              );
  
            if (pageNumber > 0) {
  
              pdf.addPage();
  
              pdf.setFontSize(16);
  
              pdf.text(
                `${title} (${start + 1} - ${end})`,
                pageWidth / 2,
                15,
                {
                  align: "center"
                }
              );
            }
  
            pdf.addImage(
              imgData,
              "JPEG",
  
              sideMargin,
              topMargin,
  
              imgWidth,
              sliceHeight *
              pxToMm
            );
  
            renderedHeight +=
              sliceHeight;
  
            pageNumber++;
          }
  
          pdf.save(
            `${filename}_${start + 1}_to_${end}.pdf`
          );
  
          document.body.removeChild(
            table
          );
        }
  
        setCurrentPage(previousPage); //Added New Line
  
      } catch (error) {
  
        console.error(
          "PDF Export Error:",
          error
        );
  
        alert(
          "Error while downloading PDF"
        );
  
      } finally {
  
        setloading(false);
        setExportingPDF(false);
      }
    };

    
  const openProgressModal = (images, location) => {
    console.log("image and location ", images, location);
    try {
      const parsedImages = JSON.parse(images || "[]");
      const parsedLocations = JSON.parse(location || "[na]");

      let imageArray = [];

      parsedImages.forEach((img) => {
        try {
          const nested = JSON.parse(img);

          if (Array.isArray(nested)) {
            imageArray.push(...nested);
          } else {
            imageArray.push(img);
          }
        } catch {
          imageArray.push(img);
        }
      });

      // const combinedData = imageArray.map((image, index) => {
      //   let locationObj = {};

      //   try {
      //     locationObj = JSON.parse(parsedLocations[index] || "{}");
      //   } catch (err) {
      //     console.log(err);
      //   }

      //   return {
      //     image,
      //     location: locationObj,
      //   };
      // });
      const combinedData = imageArray.map((image, index) => {
        let locationObj = {};

        const loc = parsedLocations[index];

        if (loc && loc !== "na" && loc !== "null" && loc !== "") {
          try {
            locationObj = JSON.parse(loc);
          } catch (err) {
            console.error("Invalid location JSON:", loc, err);
          }
        }

        return {
          image,
          location: locationObj,
        };
      });
      console.log("combinedData", combinedData);

      setProgressData(combinedData);
      setShowProgressModal(true);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!progressData?.length) return;

      if (e.key === "ArrowRight") {
        setSelectedImageIndex(
          (prevIndex) => (prevIndex + 1) % progressData.length,
        );
      }

      if (e.key === "ArrowLeft") {
        setSelectedImageIndex(
          (prevIndex) =>
            (prevIndex - 1 + progressData.length) % progressData.length,
        );
      }

      // Optional: close image/modal with Escape
      // if (e.key === "Escape") {
      //   setSelectedImageIndex(null);
      // }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [progressData]);

  const isChecker =
    RoleID === 80 ||
    RoleID === 81 ||
    ((RoleID === 40 || RoleID === 41) &&
      (SelectedDistrict.includes("जालना") ||
        SelectedDistrict.includes("नांदेड"))) ||
    ((LoggedUserDistrict === "जालना" ||
      LoggedUserDistrict === "नांदेड") &&
      SelectedHeadCode?.startsWith("2515"));

  const talukaOptions = [
    ...new Set(
      progressList
        ?.filter((item) => {
          // State login → selected district
          if (SelectedDistrict?.length > 0) {
            return SelectedDistrict.some(
              (district) => {
                const itemDistrict =
                  item.District || item.District_Marathi || "";

                return (
                  itemDistrict === district ||
                  itemDistrict.startsWith(`${district}-`)
                );
              }
            );
          }

          // District login → logged-in user's district
          if (LoggedUserDistrict) {
            const itemDistrict =
              item.District || item.District_Marathi || "";

            return (
              itemDistrict === LoggedUserDistrict ||
              itemDistrict.startsWith(`${LoggedUserDistrict}-`)
            );
          }

          return true;
        })
        .map((item) => item.Taluka)
        .filter(Boolean)
    ),
  ].sort();

  return (
    <div
      className="col-12 pb-5"
      style={{
        backgroundColor: "#EFF3F8",
        height: "90vh",
        overflowX: "hidden",
        overflowY: "scroll",
        position: "relative",
      }}
    >
      {/* 🔥 Blur Wrapper */}
      <div
        style={{
          filter: loading ? "blur(4px)" : "none",
          pointerEvents: loading ? "none" : "auto",
          transition: "0.2s ease",
        }}
      >
        <div className="col-11 m-auto">
          <div className="col-12">
            {/* <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h5 className='my-auto fw-bold'>
                            <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                            <span className='my-auto'>{t('Progress Report Outwards')}</span>
                        </h5>

                        <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
                            <select
                                placeholder='Choose District'
                                value={statusofData}
                                onChange={(e) => setstatusofData(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "8px 12px 8px 8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "#ffffffff",
                                    fontSize: "18px",
                                    color: "#333",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                    outline: "none"
                                }}>
                                <option value="">All</option>
                                <option value="Pending">Pending</option>
                                <option value="Rejected">Rejected</option>

                            </select>
                        </div>

                        {
                            UserRole == "State" && (
                                <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
                                    <select
                                        placeholder='Choose District'
                                        value={SelectedDistrict}
                                        onChange={(e) => setSelectedDistrict(e.target.value)}
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px 8px 8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                            backgroundColor: "#ffffffff",
                                            fontSize: "18px",
                                            color: "#333",
                                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                            outline: "none"
                                        }}>
                                        <option value="" >{t("Select District")}</option>
                                        {
                                            AllDistrict &&
                                            [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
                                                return (
                                                    <option key={index} value={district}>{district}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            )
                        }

                        {
                            UserRole == "State" && (
                                <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
                                    <select
                                        placeholder='Choose Taluka'
                                        value={SelectedTalukasofDistrict}
                                        onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px 8px 8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                            backgroundColor: "#ffffffff",
                                            fontSize: "18px",
                                            color: "#333",
                                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                            outline: "none"
                                        }}>
                                        <option value="" disabled>Select Taluka</option>
                                        {
                                            TalukasofDistrict.length > 0 &&
                                            TalukasofDistrict.map((val, index) => {
                                                return (
                                                    <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            )
                        }

                        <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
                            <img
                                src="/Search32.png"
                                alt="Search Icon"
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                    width: "16px",
                                    height: "16px",
                                    opacity: 0.6
                                }}
                            />
                            <input
                                type="text"
                                placeholder={t('Search')}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                value={searchTerm}
                                style={{
                                    width: "100%",
                                    padding: "8px 12px 8px 32px",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "#f1f6fc",
                                    fontSize: "18px",
                                    color: "#333",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                    outline: "none"
                                }}
                            />
                        </div>
                          <div className='col-4'> 

                            <button className='btn btn-success ' onClick={() => exportTableByClassToExcel(sortedProgress, "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
                                    </div>
                    </div> */}
            <div
              className="col-12 px-4 mb-4 mt-3"
              style={{
                filter: loading ? "blur(4px)" : "none",
                pointerEvents: loading ? "none" : "auto",
                transition: "0.2s ease",
              }}
            >
              {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
              <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <h5 className="fw-bold d-flex align-items-center m-0">
                  <img
                    src="/GR-Approval64.png"
                    alt="Technical Approval"
                    style={{
                      width: "24px",
                      height: "24px",
                      marginRight: "6px",
                    }}
                  />
                  {[24, 25, 29, 40, 41].includes(RoleID)
                    ? t("Progress Report Status")
                    : t("Progress Report Outwards")}
                </h5>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-success"
                    onClick={() =>
                      exportTableByClassToExcel(
                        sortedProgress,
                        "Progress Report Outward List.xlsx",
                      )
                    }
                  >
                    {t("Download Excel")}
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      downloadTableOnlyAsPDF(
                        "ProgressReport",
                        "ProgressReport.pdf",
                        "Progress Report outward",
                      )
                    }
                  >
                    {t("Download PDF")}
                  </button>
                </div>
              </div>

              {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
              <CommonFilters
                UserRole={UserRole}

                // {/* Data Type */}
                showDataType={
                  UserRole === "State" && RoleID == 29
                }
                typeofData={typeofData}
                settypeofData={settypeofData}
                
                // {/* Department */}
                 showDepartment={showDepartmentFilter}
                selectedDepartment={selectedDepartment}
                setSelectedDepartment={setSelectedDepartment}
                

                // {/* Status */}/
                showStatus={true}
                statusofData={statusofData}
                setstatusofData={setstatusofData}

                // {/* Head Code */}
                showHeadCode={
                  UserRole !== "State" &&
                  RoleID !== 80 &&
                  RoleID !== 81
                }
                selectedHeadCode={SelectedHeadCode}
                setSelectedHeadCode={setSelectedHeadCode}
                headCodeOptions={[
                  ...new Set(
                    progressList
                      ?.map((item) => item.Head_Code)
                      .filter(Boolean)
                  ),
                ].sort()}

                // {/* District */}
                showDistrict={UserRole === "State"}
                SelectedDistrict={SelectedDistrict}
                AllDistrict={AllDistrict}
                openDistrict={openDistrict}
                setOpenDistrict={setOpenDistrict}
                isAllSelected={isAllSelected}
                toggleAllDistricts={toggleAllDistricts}
                handleDistrictToggle={handleDistrictToggle}

                // {/* Taluka */}
                showTaluka={true}
                SelectedTaluka={SelectedTalukasofDistrict}
                setSelectedTaluka={setSelectedTalukasofDistrict}
                TalukasofDistrict={talukaOptions}

                // {/* Search */}
                showSearch={true}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>

            <div className="col-12 pb-5">
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  boxShadow: "0px 0px 5px 1px #E4E8EC",
                  borderRadius: "20px",
                  width: "100%",
                  maxWidth: "100%",
                  overflowX: "hidden",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{ background: "#2C78DB", overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}
                >
                  <table
                    className="m-0 p-0 ProgressReport"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                        }}
                      >
                        <th style={{ padding: "7px 10px", minWidth: "60px" }}>
                          {t("Sr.No.")}
                        </th>
                        {UserRole === "State" && RoleID != 29 ? (
                          ""
                        ) : (
                          <th
                            style={{ padding: "7px 10px", minWidth: "200px" }}
                          >
                            {t("Head Code")}
                          </th>
                        )}
                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                          {t("Year")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                          {t("MHUID Number")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                          {t("Work Name")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                          {t("Job ID")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                          {t("District")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                          {t("Taluka")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                          {t("Physical Progress (%)")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "220px" }}>
                          {t("File Upload")}
                        </th>
                        {/* <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                          {t("Location")}
                        </th> */}
                        <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                          {t("Creation Date")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                          {t("Rejected?")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                          {t("Rejected By")}
                        </th>
                        <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                          {t("Remark")}
                        </th>
                        <th style={{ minWidth: "150px", padding: "8px" }}>
                          {isChecker
                            ? t("Maker")
                            : t("Deputy Engineer Approval")}
                        </th>
                        {(isChecker) && (
                          <th style={{ minWidth: "150px", padding: "8px" }}>
                            {t("Checker")}
                          </th>
                        )}
                        {/* <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Department HOD Approval")}</th> */}
                      </tr>
                    </thead>

                    <tbody>
                      {displayedGRS?.length === 0 ? (
                        <tr>
                          <td
                            colSpan="16"
                            style={{
                              textAlign: "center",
                              padding: "20px",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            {t("No data available")}
                          </td>
                        </tr>
                      ) : (
                        displayedGRS?.map((proposal, index) => {
                          const bgColor =
                            index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                          const statusBox = (value) => {
                            if (value === "true") {
                              return (
                                <div
                                  className="m-auto"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "6px",
                                    backgroundColor: "#16C60C",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "white",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ✓
                                </div>
                              );
                            } else if (value === "false") {
                              return (
                                <div
                                  className="m-auto"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "6px",
                                    backgroundColor: "#dc2626",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "white",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ✕
                                </div>
                              );
                            } else {
                              return "-";
                            }
                          };

                          return (
                            <tr
                              style={{
                                backgroundColor: bgColor,
                                fontSize: "18px",
                              }}
                              key={index}
                            >
                              <td style={{ padding: "8px" }}>
                                {indexOfFirstBill + index + 1}
                              </td>
                              {UserRole === "State" && RoleID != 29 ? (
                                ""
                              ) : (
                                <td style={{ padding: "8px" }}>
                                  {proposal.Head_Code || "-"}
                                </td>
                              )}
                              <td style={{ padding: "8px" }}>
                                {proposal.ProposalYear || "-"}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {/* {proposal.TechnicalUID || "-"} */}
                                {!proposal.TechnicalUID ||
                                String(proposal.TechnicalUID).trim().toUpperCase() === "NULL" ||
                                String(proposal.TechnicalUID).trim().toLowerCase() === "undefined" ||
                                String(proposal.TechnicalUID).trim() === ""
                                  ? "-"
                                  : proposal.TechnicalUID}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {proposal.WorkOrderNo || "-"}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {proposal.JOB_ID || "-"}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {proposal.District || "-"}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {proposal.Taluka || "-"}
                              </td>
                              <td>
                                <span
                                  style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    openProgressModal(
                                      proposal.Upload,
                                      proposal.Location,
                                    )
                                  }
                                >
                                  {proposal.physicalValue}%
                                </span>
                              </td>

                              {/* UPDATED FILE UPLOAD SECTION TO HANDLE ARRAYS */}
                              <td style={{ padding: "8px" }}>
                                {(() => {
                                  if (!proposal.Upload) {
                                    return (
                                      <span className="text-danger fw-bold">
                                        No File
                                      </span>
                                    );
                                  }

                                  let files = [];
                                  try {
                                    // Check if it matches JSON array format ["file1","file2"]
                                    const parsed = JSON.parse(proposal.Upload);
                                    if (Array.isArray(parsed)) {
                                      files = parsed;
                                    } else {
                                      // Fallback if parsing works but result isn't an array
                                      files = [proposal.Upload];
                                    }
                                  } catch (error) {
                                    // If parsing fails, it's likely a simple string filename
                                    files = [proposal.Upload];
                                  }

                                  return files.map((fileName, fIndex) => (
                                    <div
                                      key={fIndex}
                                      style={{ marginBottom: "4px" }}
                                    >
                                      <a
                                        href={`${apiurl}/Uploads/${fileName}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        title={fileName}
                                      >
                                        {/* Display filename, truncated if too long */}
                                        {fileName.length > 25
                                          ? fileName.substring(0, 25) + "..."
                                          : fileName}
                                      </a>
                                    </div>
                                  ));
                                })()}
                              </td>
                              {/* <td style={{ padding: "8px" }}>
                                {(() => {
                                  if (!proposal.Location) {
                                    return <span>NA</span>;
                                  }

                                  let locations = [];

                                  try {
                                    locations = JSON.parse(proposal.Location);
                                  } catch (err) {
                                    return <span>NA</span>;
                                  }

                                  // Check if all locations are "na"
                                  const allNA = locations.every(
                                    (loc) => loc === "na",
                                  );

                                  if (allNA) {
                                    return <span>NA</span>;
                                  }

                                  return locations.map((loc, index) => (
                                    <div key={index}>
                                      {loc !== "na" && <span>{loc}</span>}
                                    </div>
                                  ));
                                })()}
                              </td> */}
                              <td style={{ padding: "8px" }}>
                                {proposal.Date
                                  ? new Date(proposal.Date).toLocaleString(
                                      "en-IN",
                                    )
                                  : "-"}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {proposal.Status == "Pending" ? "NO" : "YES"}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {proposal.Rejected_By || "-"}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {proposal.Remark || "-"}
                              </td>
                              <td
                                style={{ padding: "8px", textAlign: "center" }}
                              >
                                {statusBox(proposal.Approvance1)}
                              </td>
                              {(isChecker) && (
                              <td style={{ padding: "8px", textAlign: "center" }}>
                                {statusBox(proposal.Approvance2)}
                              </td> )}
                              {/* <td style={{ padding: "8px", textAlign: "center" }}>
                                {statusBox(proposal.Approvance2)}
                              </td> */}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="col-12 mt-4 mb-2">
                  <div className="row">
                    <div className="col-6">
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredProgress.length)}{" "}
                        {t("of")} {totalProgressCount} {t("entries")}
                      </p>
                    </div>
                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showProgressModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Physical Progress Images</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowProgressModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  {progressData?.length > 0 ? (
                    progressData.map((item, index) => (
                      <div className="col-md-4 mb-3" key={index}>
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            padding: "10px",
                            background: "#fff",
                          }}
                        >
                          <img
                            src={`${apiurl}/UploadProgressDocsImages/${item?.image}`}
                            alt="Document"
                            style={{
                              width: "120px",
                              cursor: "pointer",
                              maxHeight: "250px",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              setSelectedImageIndex(index);
                              setSelectedImage(
                                `${apiurl}/UploadProgressDocsImages/${item.image}`,
                              );
                              setShowImageModal(true);
                            }}
                          />
                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "18px",
                              lineHeight: "1.7",
                            }}
                          >
                            <div>
                              📍 <strong>Latitude:</strong>{" "}
                              {item.location?.latitude || "-"}
                            </div>

                            <div>
                              📍 <strong>Longitude:</strong>{" "}
                              {item.location?.longitude || "-"}
                            </div>

                            <div>
                              📅 <strong>Date:</strong>{" "}
                              {item.location?.date || "-"}
                            </div>

                            <div>
                              🕒 <strong>Time:</strong>{" "}
                              {item.location?.time || "-"}
                            </div>

                            <div>
                              ⛰️ <strong>Elevation:</strong>{" "}
                              {item.location?.elevation || "-"} m
                            </div>

                            <div>
                              🎯 <strong>Accuracy:</strong>{" "}
                              {item.location?.accuracy || "-"} m
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Images Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImageModal && (
        <div
          // onClick={() => setShowImageModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >   <button
            onClick={(e) => {
              e.stopPropagation();
              setShowImageModal(false);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ×
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();

              const prevIndex =
                (selectedImageIndex - 1 + progressData.length) %
                progressData.length;

              setSelectedImageIndex(prevIndex);
            }}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              cursor: "pointer",
            }}
          >
            ❮
          </button>
          <img
            src={`${apiurl}/UploadProgressDocsImages/${progressData[selectedImageIndex]?.image}`}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              background: "rgba(0,0,0,0.5)",
              padding: "6px 12px",
              borderRadius: "20px",
            }}
          >
            {selectedImageIndex + 1} / {progressData.length}
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();

              const nextIndex = (selectedImageIndex + 1) % progressData.length;

              setSelectedImageIndex(nextIndex);
            }}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ❯
          </button>
        </div>
      )}

      {/* {showImageModal && (
        <div
          onClick={() => setShowImageModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={selectedImage}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />

          <button
            onClick={() => setShowImageModal(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
      )} */}

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.4)",
            backdropFilter: "blur(2px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="Adminloader"></div>
        </div>
      )}
    </div>
  );
};

export default PrograseList;
